import { render, staticRenderFns } from "./DebtRL.vue?vue&type=template&id=497205c0"
import script from "./DebtRL.vue?vue&type=script&lang=js"
export * from "./DebtRL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports